<template>
  <div class="image-list">
    <div class="add">
      <label for.prop="$refs.addImageFile">
        <i class="iconfont icon-plus"></i>
        <input type="file" ref="addImageFile" @change="addImage" accept="image/*">
        <div class="preview" v-if="base64">
          <img :src="base64">
        </div>
      </label>
    </div>
    <div class="img"></div>
    <div class="img"></div>
    <div class="img"></div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  data() {
    return {
      imageList: []
    }
  },
  methods: {
    addImage() {}
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .image-list{
    @include flex();
    justify-content: flex-start;
    flex-wrap: wrap;
    >div{
      width: size(154);
      height: size(154);
      background-color: #F1F1F1;
      margin-right: size(20);
      margin-top: size(20);
      background-color: #F1F1F1;
      &.add{
        label{
          display: block;
          width: 100%;
          height: 100%;
          position: relative;
          i{
            position: absolute;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            -o-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            color: #aaa;
            font-size: size(38);
          }
        }
        input{
          display: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/image-list.vue